import React, { useContext } from "react";
import { Button, Layout, BlockStack, Text, TextField, Card, InlineStack } from "@shopify/polaris";

// import context
import { PrivateContext } from "lib/context";
import PropTypes from "prop-types";

const PaymentSection = (props) => {
  const { toggleSection, isPaymentEnable, paymentLoading } = props;
  const { cms = {} } = useContext(PrivateContext);
  const getPaymentSectionTitle = () => {
    return (
      <InlineStack wrap={false} align="space-between">
        <Text variant="headingLg" as="p">
          {cms("section.payment.title")}
        </Text>
        <Button
          variant="primary"
          tone={isPaymentEnable ? "critical" : "success"}
          onClick={toggleSection}
          loading={paymentLoading}
        >
          {isPaymentEnable ? cms("button.disable") : cms("button.enable")}
        </Button>
      </InlineStack>
    );
  };

  const getFields = () => {
    const fields = [
      {
        label: cms("section.payment.label.bank"),
        placeholder: cms("section.payment.placeHolder.bank"),
        isRequired: true,
      },
      {
        label: cms("section.payment.label.account"),
        placeholder: cms("section.payment.placeHolder.account"),
        isRequired: true,
      },
      {
        label: cms("section.payment.label.sortCode"),
        placeholder: cms("section.payment.placeHolder.sortCode"),
        isRequired: true,
      },
      {
        label: cms("section.payment.label.country"),
        placeholder: cms("section.payment.placeHolder.country"),
        isRequired: true,
      },
    ];
    return fields.map(({ label, placeholder, isRequired }) => {
      const required = isRequired ? "*" : "";
      return (
        <>
          <TextField label={`${label}${required}`} placeholder={placeholder} value="" disabled />
          <br />
        </>
      );
    });
  };
  return (
    <div>
      <Layout.AnnotatedSection title={getPaymentSectionTitle()} description={cms("section.payment.description")}>
        <Card>
          <Text as="h6" variant="headingSm">
            {cms("section.payment.subTitle")}
          </Text>
          <Text as="p">{cms("section.payment.subDescription")}</Text>
          <BlockStack>
            <br />
            {getFields()}
          </BlockStack>
        </Card>
      </Layout.AnnotatedSection>
    </div>
  );
};

PaymentSection.propTypes = {
  toggleSection: PropTypes.func.isRequired,
  isPaymentEnable: PropTypes.bool.isRequired,
  paymentLoading: PropTypes.bool.isRequired,
};

export default PaymentSection;
